import React from "react";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";

const MyCloseIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
    <path
      d="M6 6l12 12M18 6L6 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const MyZoomInIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
    <path
      d="M11 7v8M7 11h8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M21 21l-4.3-4.3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle
      cx="11"
      cy="11"
      r="7"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

const MyZoomOutIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
    <path
      d="M7 11h8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M21 21l-4.3-4.3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle
      cx="11"
      cy="11"
      r="7"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export default function BlogLightbox({
  open,
  close,
  src,
  slides,
  backgroundColor = "#E9E9E9",
  ...lightboxProps
}) {
  const resolvedSlides =
    slides ?? (src ? [{ src }] : []);

  return (
    <Lightbox
      className="blog-lightbox"
      open={open}
      close={close}
      slides={resolvedSlides}
      styles={{
        container: {
          backgroundColor
        }
      }}
      plugins={[Zoom]}
      carousel={{
        finite: true,
        preload: 0
      }}
      controller={{
        closeOnPullDown: true,
        closeOnBackdropClick: true
      }}
      render={{
        buttonPrev: () => null,
        buttonNext: () => null,
        iconClose: () => <MyCloseIcon />,
        iconZoomIn: () => <MyZoomInIcon />,
        iconZoomOut: () => <MyZoomOutIcon />
      }}
      {...lightboxProps}
    />
  );
}

